import {findModelImagePartByHashedId} from '@Components/ai-chat-window/lib/ai-chat-messages.library';

/** The compact form of the size the chat image was asked for, or null when it has none; hashed ids are unique across chats. */
export const getTargetSizeCompactForChatImage = (hashedId: string): string | null => {
  for (const chatState of Object.values(window.PMW.redux.store.getState().aiChatWindow)) {
    const imagePart = findModelImagePartByHashedId(chatState?.messages, hashedId);
    if (imagePart !== null) {
      return imagePart.targetSizes?.[0]?.compact ?? null;
    }
  }

  return null;
};
